import { TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import rp from "@reporting/rp-app-host";

export class ModelTreeAdapter extends TreeAdapter {

	async getTree(): Promise<TreeSource> {
		const models = await rp.ms('ai').get<string[]>('models');
		return models.map(model => ({
			k: model,
			v: model,
			l: 0,
			icon: 'robot'
		}));
	}

	getOptions(): TreeOptions {
		return {
			globalLevels: false,
			selectMode: 'single',
			search: true,
			autoClose: true
		};
	}

}
